import { IconImg } from "contents/Images";
import { StyledTooltip } from "./style";
import {
  CSSProperties,
  ReactNode,
  RefObject,
  useEffect,
  useState,
} from "react";
import TooltipPortal from "components/portal/TooltipPortal/TooltipPortal";

export type TooltipDirectionType =
  | "top"
  | "top-left"
  | "top-right"
  | "bottom"
  | "bottom-left"
  | "bottom-right"
  | "right"
  | "right-top"
  | "right-bottom"
  | "left"
  | "left-top"
  | "left-bottom";

export interface TooltipProps {
  parentRef?: React.RefObject<HTMLElement>;
  direction: TooltipDirectionType;
  label: string | ReactNode;
  noPermission?: boolean;
  disabledMessage?: string;
  wordWrap?: boolean;
  noMaxWidth?: boolean; // 일부 화면에서 너비를 제한하지 않아야 하는 부분이 있어 추가
}

export const Tooltip = ({
  parentRef,
  direction,
  label,
  noPermission,
  disabledMessage,
  wordWrap = true,
  noMaxWidth = false,
}: TooltipProps) => {
  const [parentBoxRect, setParentBoxRect] = useState({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    if (parentRef?.current) {
      const rect = parentRef.current.getBoundingClientRect();
      setParentBoxRect(rect);
    }
  }, []);

  const TooltipRender = ({ style }: { style?: CSSProperties }) => {
    return (
      <StyledTooltip
        direction={direction}
        $wordWrap={wordWrap}
        $noMaxWidth={noMaxWidth}
        className="tooltip-box"
        style={style}
      >
        <IconImg.Polygon1 className="tail" />
        {typeof label === "string" ? (
          <p className="label">
            {label}
            {noPermission && !disabledMessage && (
              <span className="disabled">
                You do not have permission to access the requested.
              </span>
            )}
            {disabledMessage && !noPermission && (
              <span className="disabled">{disabledMessage}</span>
            )}
          </p>
        ) : (
          label
        )}
      </StyledTooltip>
    );
  };

  if (parentRef) {
    return (
      <TooltipPortal>
        <div
          className="parent-box"
          style={{
            background: "red",
            pointerEvents: "none",
            position: "absolute",
            width: parentBoxRect.width + "px",
            height: parentBoxRect.height + "px",
            left: parentBoxRect.left + "px",
            top: parentBoxRect.top + "px",
          }}
        >
          <TooltipRender />
        </div>
      </TooltipPortal>
    );
  }

  return <TooltipRender />;
};
